import { Component, Shark } from "shark-mvc";
// import $ from "jquery";
import { Modal } from "bootstrap";

import OrganizationMembership from "../../models/OrganizationMembership";

import templateContent from "./invite-user-modal.html";

import organizationMemberManager from "../../managers/organizationMembershipManager";

class InviteUserComponent extends Component {
	constructor () {
		super("inviteUserComponent");

		this.addTemplate("", templateContent);
	}
	
	afterLoad () {
		this.modal = new Modal(document.querySelector("#inviteUserModal"));
	}

	close () {
		this.set({
			open: false,
		});
		if (this.modal) {
			this.modal.hide();
		}
		// $("#inviteUserModal").modal("hide");
	}

	init () {
		Shark.set({
			_inviteUserModalInviteBtnStatusCSSClasses: "btn-success",
		});
		this.set({
			open: false,
		});
	}

	inviteUserModalCancelBtn_clickHandler () {
		this.close();
	}
	
	inviteUserModalEmailField_changeHandler () {
		const { currInvitingUser } = Shark.get();
		document.querySelectorAll(`[data-sh-prop="inviteEMail"]`).forEach(item => currInvitingUser.validateEmail() != [] ? item.classList.remove("invalid") : item.classList.add("invalid")); 
	}
	
	inviteUserModalMemberNameField_changeHandler () {
		const { currInvitingUser } = Shark.get();
		document.querySelectorAll(`[data-sh-prop="inviteName"]`).forEach(item => currInvitingUser.validateMemberName() != [] ? item.classList.remove("invalid") : item.classList.add("invalid")); 
	}

	async inviteUserModalInviteBtn_clickHandler () {
		// Dave: qui dovrei valutare se l'indirizzo eMail esiste già nelle mie richieste.
		const { currInvitingUser } = Shark.get();

		if (currInvitingUser) {
			const validationError = currInvitingUser.validate();

			if (validationError.length > 0) {
				validationError.forEach(error => {
					document.querySelectorAll(`[data-sh-prop="${error.field}"]`).forEach(item => item.classList.remove("invalid")); 
					setTimeout(() => {
						document.querySelectorAll(`[data-sh-prop="${error.field}"]`).forEach(item => item.classList.add("invalid")); 
					}, 250);
				});
			}
			else {
				Shark.set({
					_inviteUserModalInviteBtnStatusCSSClasses: "btn-warning disabled",
				});
				const inviteUserResonse = await organizationMemberManager.save(currInvitingUser);

				Shark.set({
					_inviteUserModalInviteBtnStatusCSSClasses: "btn-success",
				});
				// console.log({inviteUserResonse});
				if (inviteUserResonse.status === "ok") {
					this.emit("userInvited", inviteUserResonse.data);
					alert("Invito inviato correttamente, quando l'utente accetterà la richiesta potrai gestirne i permessi!");
					this.close();
				}
				else {
					alert("Mi spiace, si è verificato un errore!");
				}
			}
		}
	}

	open () {
		const { editingOrganization } = Shark.get();

		if (editingOrganization) {
			const currInvitingUser = new OrganizationMembership({
				inviteEMail: "",
				inviteMessage: "",
				organizationGuid: editingOrganization.guid,
				role: OrganizationMembership.ROLE_USER,
				status: OrganizationMembership.STATUS_PENDING,
			});
			
			// console.log(currInvitingUser);

			Shark.set({
				currInvitingUser,
			});
			Shark.render();
			
			if (this.modal) {
				this.modal.show();
			}
		}
	}

	openInviteUserModalBtn_clickHandler () {
		this.open();
	}
}

const inviteUserComponent = new InviteUserComponent();

Shark.registerComponent(inviteUserComponent);

export default inviteUserComponent;